/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReviewDto } from '../../models/review-dto';

export interface ReviewAdminControllerDeleteV1$Params {
  id: string;
}

export function reviewAdminControllerDeleteV1(http: HttpClient, rootUrl: string, params: ReviewAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ReviewDto>> {
  const rb = new RequestBuilder(rootUrl, reviewAdminControllerDeleteV1.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReviewDto>;
    })
  );
}

reviewAdminControllerDeleteV1.PATH = '/api/v1/reviews/admin/{id}';
